import { MAX_VALUE_CONSTRAINTS, VALIDATION_MESSAGES } from './constants';

export interface PhysicalPiecesValidationParams {
  enableChangeInPhysicalPiecesOption?: boolean;
  isPhysicalPiecesChanged?: boolean;
  value?: number | string | null;
}

export const getPhysicalPiecesValidationError = ({
  enableChangeInPhysicalPiecesOption,
  isPhysicalPiecesChanged,
  value
}: PhysicalPiecesValidationParams): string | null => {
  if (!enableChangeInPhysicalPiecesOption || !isPhysicalPiecesChanged) {
    return null;
  }

  const isPhysicalPiecesEmpty = value === '' || value === null || value === undefined;
  if (isPhysicalPiecesEmpty) {
    return VALIDATION_MESSAGES.REQUIRED;
  }

  const maxAllowedPhysicalPieces = MAX_VALUE_CONSTRAINTS.DELIVERY_PRO_FORM.PHYSICAL_PIECES;
  const isPhysicalPiecesInvalidNumber = Number(value) <= 0 || Number(value) > maxAllowedPhysicalPieces;

  if (isPhysicalPiecesInvalidNumber) {
    return `* Enter a value between 1 and ${maxAllowedPhysicalPieces}`;
  }

  return null;
};

